import React from "react";

import Styled from "./style";

const Highlights = () => {
  return (
    <Styled>
      <p className="title is-6">Trusted by the leading startups</p>
      <div className="logos">
        <img
          src="https://res.cloudinary.com/svmszcck/image/upload/v1612516722/hotjar_logo_htokrx.png"
          alt="Hotjar"
        />
        <img
          src="https://res.cloudinary.com/svmszcck/image/upload/v1571866499/clevertech_y8acqr.png"
          alt="Clevertech"
        />
        <img
          src="https://res.cloudinary.com/svmszcck/image/upload/v1572585264/rbt2htwe7a5ll1xgjhfo.png"
          alt="Shogun"
        />
        <img
          src="https://res.cloudinary.com/svmszcck/image/upload/v1612516269/logo_267_ojklfz.png"
          alt="X-Team"
        />
      </div>
    </Styled>
  );
};

export default Highlights;
